import request from "_private/utils/request";

/**
 * 获取批次赋码追溯列表数据
 * @param {*} data
 */
export function batchTrace(data) {
  return request({
    url: "/coldTrace/batchTrace",
    method: "post",
    headers: { type: "json" },
    data
  });
}
// 导出批次赋码追溯页面数据
export function exportBatchTrace(data) {
  return request({
    headers: { "Content-Type": "application/json", type: "json" },
    responseType: "blob",
    url: "/coldTrace/exportBatchTrace",
    method: "post",
    data
  });
}
// 批次赋码详情
export function tagCodeDetail(params) {
  return request({
    headers: { type: "json" },
    url: "/coldTrace/tagCodeDetail",
    method: "get",
    params
  });
}

// 批次查询详情
export function tagCodeQueryRecord(params) {
  return request({
    headers: { type: "json" },
    url: "/coldTrace/tagCodeQueryRecord",
    method: "get",
    params
  });
}
